export const currentURL = window.location.origin;

// Construct share URLs for different platforms
export const facebookShareURL = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentURL)}`;
export const twitterShareURL = `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentURL)}`;
export  const whatsappShareURL = `https://api.whatsapp.com/send?text=${encodeURIComponent(currentURL)}`;